(function(){
    angular.module('tmx-app').directive("tmxInput", tmxInput);

    function tmxInput() {
	    return {
	    	scope:{
	    		field:'='
	    	},
	        restrict: 'E',
	        replace: true,
	        priority: 100,
	        templateUrl: 'common/directives/tmxinput/tmxinput.html',
		    controller: ["$scope",tmxInputCtrl],
		    controllerAs:'inputCtrl'
	    };
    }

    function tmxInputCtrl($scope){
        var inputCtrl=this;
        inputCtrl.scope=$scope;
		
        inputCtrl.isRegularInput=function(){
            var is=!inputCtrl.isSelect() &&
				   !inputCtrl.isDatePicker();
            return is;
        }

        inputCtrl.isDatePicker=function(){
            return	inputCtrl.scope.field.type==='datepicker';
        }

        inputCtrl.isSelect=function(){
            return	inputCtrl.scope.field.type==='select';
        }
			
    }
})();